import { fetchAuthSession } from "aws-amplify/auth";
import {
  getNormalizedErrorMessage,
  isTokenExpiredError,
  isRecoverableSubscriptionError,
} from "./subscription-error-utils";

export { getNormalizedErrorMessage, isTokenExpiredError, isRecoverableSubscriptionError };

/**
 * Calculate exponential backoff delay
 * @param attempt - Current attempt number (0-indexed)
 * @param baseDelay - Base delay in milliseconds (default: 1000ms)
 * @param maxDelay - Maximum delay in milliseconds (default: 30000ms = 30s)
 * @returns Delay in milliseconds
 */
export const calculateBackoffDelay = (
  attempt: number,
  baseDelay: number = 1000,
  maxDelay: number = 30000
): number => {
  // Exponential backoff: baseDelay * 2^attempt
  const delay = baseDelay * Math.pow(2, attempt);
  // Cap at maxDelay to prevent excessive delays
  return Math.min(delay, maxDelay);
};

/**
 * Get a fresh ID token from Amplify
 * Amplify handles token refresh automatically if needed
 */
export const getFreshIdToken = async (): Promise<string> => {
  const session = await fetchAuthSession({ forceRefresh: true });
  const idToken = session.tokens?.idToken;

  if (!idToken) {
    throw new Error("No authentication token available after refresh");
  }

  return idToken.toString();
};
